import React from "react";
import { Record, useTranslate } from "react-admin";
import { VehicleMaintenanceSummaryDto } from "./types";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import WarningIcon from "@material-ui/icons/Warning";
import { ArrayField } from "../../common/data-grid-fields/ArrayField";
import { Theme, Typography, useTheme } from "@material-ui/core";
import "./TiresStatusField.css";

interface Props {
  label?: string;
  record?: VehicleMaintenanceSummaryDto & Record;
}

export const TiresStatusField = (props: Props) => {
  const { record } = props;
  const theme: Theme = useTheme();
  const translate = useTranslate();
  if (!record) {
    return null;
  }

  if (!record.tiresFaulty) {
    return (
      <div className="tire-faults-container">
        <CheckBoxIcon
          style={{
            color: theme.palette.success.main,
          }}
        />
        <Typography variant="body2">
          {translate("resources.assets-maintenance.labels.noProblemReported")}
        </Typography>
      </div>
    );
  }

  return (
    <div className="tire-faults-container">
      <WarningIcon
        style={{
          color: theme.palette.error.main,
        }}
      />
      <ArrayField source="tireFaults" displayedElementsCount={1} {...props} />
    </div>
  );
};
